module.exports = __webpack_public_path__ + "static/img/szafa_dso_24.44f59c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/kopai/szafa_dso_24.svg
// module id = Q0/K
// module chunks = 1